// @flow
import React from 'react';
import Card from '../../components/Card';
import { H2 } from '../../components/Typography';
import styles from './styles.module.scss';
import P from '../../components/Typography/P';
import CustomLink from '../../components/CustomLink/Link';
import routes from '../../constants/routes';

const EmailNotification = () => (
  <Card
    use="light"
    className={styles.containerForm}
    title={<H2 color="dark" className={styles.title}>Sent to your Email</H2>}
  >
    <P
      use="dark"
      size="small"
    >
      Please check your email for password recovery link
    </P>
    <P>Back to site</P>
    <CustomLink name="Profile" use="black" to={routes.app.profile.root} />
  </Card>
);

export default EmailNotification;
